import { render, staticRenderFns } from "./WrapperCard.vue?vue&type=template&id=360e2e11&"
import script from "./WrapperCard.vue?vue&type=script&lang=js&"
export * from "./WrapperCard.vue?vue&type=script&lang=js&"
import style0 from "./WrapperCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports